import { resetAccount } from 'src/state/account/account-slice';
import { resetAddress } from 'src/state/address/address-slice';
import { resetAuth } from 'src/state/auth/auth-slice';
import { clearErrors } from 'src/state/errors/errors-slice';
import { resetRequestState } from 'src/state/request/request-slice';
import { useAppDispatch } from 'src/state/thunk-api';

export const useResetState = () => {
  const dispatch = useAppDispatch();

  const resetState = () => {
    dispatch(resetRequestState());
    dispatch(resetAddress());
    dispatch(clearErrors());
    dispatch(resetAccount());
    dispatch(resetAuth());
  };

  return { resetState };
};
